import { AlertTriangle, RefreshCcw } from 'lucide-react';
import { Button } from '@/components/ui/Button';

export function ErrorState({
  title = 'Something went wrong',
  hint,
  onRetry,
}: {
  title?: string;
  hint?: string;
  onRetry?: () => void;
}) {
  return (
    <div
      role="alert"
      className="flex flex-col items-center justify-center gap-2 px-4 py-6 text-center rounded-xl border border-rose-500/30 bg-rose-500/5 text-rose-100"
    >
      <AlertTriangle className="size-5 text-rose-300" />
      <p className="text-sm font-medium">{title}</p>
      {hint && <p className="text-xs text-rose-200/70">{hint}</p>}
      {onRetry && (
        <Button variant="secondary" size="sm" onClick={onRetry}>
          <RefreshCcw className="size-3" /> Retry
        </Button>
      )}
    </div>
  );
}
